import React, { useEffect, useState } from 'react';
import DictTagsService from '../../../services/dict/DictTagsService';
import AddDictTags from './AddDictTags';
import LanguageModal from './LanguageModal';
import Options from './Options';
import { withTranslation } from 'react-i18next';
import { DictTagsDto } from '../../../types/types';

type Props = {
    t: any;
};

const ShowDictTags: React.FC<Props> = ({ t }) => {
    const [dictTags, setDictTags] = useState<DictTagsDto[]>([]);
    const [modalVisible, setModalVisible] = useState(false);
    const [selectedTagId, setSelectedTagId] = useState<string | null>(null);

    useEffect(() => {
        loadDictTags();
    }, []);

    const loadDictTags = () => {
        DictTagsService.getDictTags() // Pass appropriate category ID if needed
            .then(response => {
                setDictTags(response.data);
            })
            .catch(error => {
                console.error('Error loading tags:', error);
            });
    };

    const handleAddTag = (newTag: DictTagsDto) => {
        setDictTags(prevTags => [...prevTags, newTag]);
        setModalVisible(false);
    };

    const handleDeleteTag = (tagDictId: string) => {
        setDictTags(prevTags => prevTags.filter(tag => tag.dict_id !== tagDictId));
    };

    const handleEditTag = (tagId: string) => {
        setSelectedTagId(tagId);
    };

    return (
        <div>
            <table>
                <thead>
                    <tr>
                        <th>{t("table.id")}</th>
                        <th>{t("table.name")}</th>
                        <th>{t("table.description")}</th>
                        <th>{t("table.actions")}</th>
                    </tr>
                </thead>
                <tbody>
                    {dictTags.map(tag => (
                        <tr key={tag.id}>
                            <td>{tag.id}</td>
                            <td>{tag.name}</td>
                            <td>{tag.description}</td>
                            <td>
                                <Options
                                    item={tag}
                                    onDeleteTag={handleDeleteTag}
                                    onEditTag={handleEditTag}
                                />
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
            <button onClick={() => setModalVisible(true)}>{t("buttons.add")}</button>
            {modalVisible && (
                <AddDictTags
                    dictTags={dictTags}
                    onAddTag={handleAddTag}
                />
            )}
            {selectedTagId && (
                <LanguageModal
                    show={!!selectedTagId}
                    onClose={() => setSelectedTagId(null)}
                    tagId={selectedTagId}
                />
            )}
        </div>
    );
};

export default withTranslation("global")(ShowDictTags);